export default __webpack_public_path__ + "static/media/NDLogo.f99ad725.png";